import { css } from 'styled-components';

export default css`
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	li,
	blockquote {
		color: ${(props) => props.theme.colors.slateBlue};
		line-height: 1.2;
		& + * {
			margin-top: 4px;
		}
	}

	h1 {
		font-size: 21px;
		font-weight: 700;
	}

	h2 {
		font-size: 19px;
		font-weight: 700;
	}

	h3 {
		font-size: 17px;
		font-weight: 700;
	}

	h1,
	h2,
	h3 {
		margin-top: 12px;
	}

	*:first-child {
		margin-top: 0;
	}

	p,
	li {
		font-size: 16px;
		line-height: 1.35;
	}

	ul {
		margin-left: 22px;
		margin-bottom: 6px;
	}

	ol {
		margin-left: 16px;
	}

	img {
		max-width: 100%;
		margin: 4px 0;
	}

	a {
		color: ${(props) => props.theme.colors.primary};
		&:hover {
			text-decoration: none;
		}
	}
`;
